// extracted by mini-css-extract-plugin
export var tagHeadline = "tag-headline-module--tag-headline--3UmNq";
export var tagHeadlineCopy = "tag-headline-module--tag-headline-copy--2rTFc";